import { Box } from 'grommet'
import styled from 'styled-components'

export const GraySectionWrapper = styled(Box)`
  margin-top: ${({ theme }) => theme.spaces[6]}px;
  position: relative;

  ${({ theme }) => theme.below.laptop`
    margin-top: ${theme.spaces[5]}px;

    .title {
      padding: 0 ${theme.spaces[2]}px;
    }
  `}

  h2.title {
    text-transform: uppercase;

    ${({ theme }) => theme.below.mobileL`
      padding: 0;
    `}
  }
`

export const SmallHexagonWrapper = styled(Box)`
  left: 79px;
  position: absolute;
  top: -53px;
  z-index: 5;

  & > svg > path {
    fill: transparent;
    transition: 0.2s all ease;
  }

  & > svg > path:hover {
    stroke-width: 7;
  }

  ${({ theme }) => theme.below.tabletXS`
    display: none;
  `}
`
